import { render, staticRenderFns } from "./PersonalDataDialog.vue?vue&type=template&id=106ed974&scoped=true&"
import script from "./PersonalDataDialog.vue?vue&type=script&lang=js&"
export * from "./PersonalDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataDialog.vue?vue&type=style&index=0&id=106ed974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ed974",
  null
  
)

export default component.exports